import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-svg-external-link',
  templateUrl: './svg-external-link.component.html',
  standalone: true,
})
export class SvgExternalLinkComponent {
  @Input() width = 16;
  @Input() height = 16;
}
